/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BenutzerEinstellungen { 
    benutzer_id: string;
    nutzungsbedingungen_akzeptiert?: boolean;
    troubletickets_sichtbar?: boolean;
    incidentmanagement_sichtbar?: boolean;
}

